/** `snippets/explore-try-something-new.liquid` — region-based ATC gating on the
 *  "Try Something New" promo card. Disables the add-to-cart button and shows a
 *  message when the featured product isn't available in the visitor's state.
 */

const REGION_LS_KEY = 'wyld_us_state'
const ROOT_SELECTOR = '[data-explore-tsn]'
const ADD_BTN_SELECTOR = '[data-tsn-add]'
const UNAVAILABLE_SELECTOR = '[data-tsn-unavailable]'

function parseJsonAttr(el, attr) {
  const raw = el.getAttribute(attr)
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function isAvailableInState(includedStates, state) {
  if (includedStates.length === 0) return true
  return includedStates.includes(state)
}

function isSoldOut(addBtn) {
  return addBtn?.dataset.available === 'false'
}

function applyRegion(root, state) {
  const addBtn = root.querySelector(ADD_BTN_SELECTOR)
  const message = root.querySelector(UNAVAILABLE_SELECTOR)
  if (!addBtn) return

  if (!state) {
    if (message) message.hidden = true
    addBtn.disabled = isSoldOut(addBtn)
    return
  }

  const included = parseJsonAttr(root, 'data-included-states')
  const available = isAvailableInState(included, state)

  if (message) message.hidden = available
  addBtn.disabled = isSoldOut(addBtn) || !available
}

function safeGet(key) {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function applyAll() {
  const state = safeGet(REGION_LS_KEY)
  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    applyRegion(root, state)
  })
}

function init() {
  applyAll()
  document.addEventListener('theme:region:state-changed', applyAll)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
